export const reload = (timeout: number = 0) => {
  setTimeout(() => window.location.reload(), timeout);
};
